import { Component, OnInit, inject } from '@angular/core';
import { CommonMigFormComponent } from '../../components/abstract/common-mig-form.component';
import { IRegexService } from '@services/common/regex.service';
import { User } from '@models/account/user.model';
import { Validators } from '@angular/forms';
import { alertFire } from '@functions/alerts';
import { createUrlTreeFromSnapshot } from '@angular/router';

@Component({
  selector: 'app-resident-page',
  templateUrl: './resident-page.component.html',
  styleUrls: ['./resident-page.component.scss'],
})
export class ResidentPageComponent
  extends CommonMigFormComponent
  implements OnInit
{
  regexService = inject(IRegexService);
  constructor() {
    super();
  }
  ngOnInit(): void {
    this.module.step = 2;
    this.group = this.builder.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
    });
    this.unsubscribe.push(
      this.module.onSubmit.subscribe(() => {
        this.onSubmit();
      })
    );
    const storage = this.module.storage;
    if (storage) {
      this.group.patchValue(storage);
    }
  }

  onSubmit() {
    this.submit = true;
    this.group.markAsTouched();
    if (this.group.valid) {
      const parameters = this.group.getRawValue();
      alertFire('This action cannot be undone!').then(result => {
        if (result.value) {
          this.module.initial$.next({
            ...this.module.initial$.value,
            ...parameters,
          });
          this.module.api
            .post<{ user: User }>(`users/bd-register`, {
              ...parameters,
              communityId: this.module.initial$.value?.community,
            })
            .subscribe({
              next: response => {
                const storage = this.module.storage;
                if (storage) {
                  this.module.setStorage({
                    ...storage,
                    ...this.group.getRawValue(),
                  });
                }
                this.module.user$.next(response.user);
                //
                this.regexService.set({
                  id: 'resident name',
                  value: `${response.user.firstName} ${response.user.lastName}`,
                });
                //
                const urlTree = createUrlTreeFromSnapshot(this.route.snapshot, [
                  response.user.id,
                ]);
                this.router.navigateByUrl(urlTree).then();
              },
            });
        }
      });
    }
  }
}
